<template>
  <div class="add-discovery-campaign">
    <ChooseCampaignOption
      v-loading="isLoading"
      class="add-discovery-campaign__box"
      :title="$t('ADVERTISEMENT.CHOOSE_CAMPAIGN.DISCOVERY')"
      :description="$t('ADVERTISEMENT.CHOOSE_CAMPAIGN.DISCOVERY_DESCRIPTION')"
      :button-text="$t('ADVERTISEMENT.NEW_CAMPAIGN_DISCOVERY')"
      :image="require('@/assets/images/campaigns/discovery-ads.svg')"
      @select="fetchRequirementsAndOpenModal"
    />
    <AddDiscoveryCampaignModal
      v-model="showDiscoveryCampaignModal"
      :apps="apps"
      :credit="credit"
      @add="emitAdd"
    />
  </div>
</template>

<script>
import { Apps, Advertisement } from '@/api/api';
import { AD_NEW_CAMPAIGN_BUTTON_CLICK } from '@/constants/gtm-events';
import ChooseCampaignOption from '../common/ChooseCampaignOption';
import AddDiscoveryCampaignModal from './AddDiscoveryCampaignModal';
import permissions from '@/mixins/permissions';

export default {
  name: 'AddDiscoveryCampaign',
  components: {
    ChooseCampaignOption,
    AddDiscoveryCampaignModal,
  },
  mixins: [permissions],
  data() {
    return {
      showDiscoveryCampaignModal: false,
      apps: [],
      credit: 0,
      isLoading: false,
    };
  },
  methods: {
    emitAdd() {
      this.$emit('add');
    },
    fetchRequirementsAndOpenModal() {
      this.$gtm.trackEvent(AD_NEW_CAMPAIGN_BUTTON_CLICK);

      this.isLoading = true;

      return Promise.all([this.getApps(), this.getCredit()])
        .then(() => {
          this.showDiscoveryCampaignModal = true;
        })
        .catch(() => {})
        .finally(() => {
          this.isLoading = false;
        });
    },
    getApps() {
      if (this.apps.length) return Promise.resolve();

      return Apps.getList()
        .then(apps =>
          apps.filter(
            app =>
              this.hasAdvertisement(app.packageName) && app.published === 'P',
          ),
        )
        .then(apps => {
          this.apps = apps;
        })
        .catch(err => {
          this.$message.error(err.message);

          throw err;
        });
    },
    getCredit() {
      return Advertisement.getDeveloperCredit()
        .then(({ body: { credit = 0 } }) => {
          this.credit = credit;
        })
        .catch(({ body: { message } = {} }) => {
          if (message) {
            this.$message.error(message);
          }

          throw new Error(message);
        });
    },
  },
};
</script>

<style lang="scss">
.add-discovery-campaign {
  &__box {
    height: 100%;
  }
}
</style>
